import { Skeleton, Typography } from '@customink/pigment-react';
import {
  useItemizedPriceData,
  usePricing,
} from '@customink/project-service-react-components';
import type { ProjectItem } from '@customink/project-service-react-components';
import Big from 'big.js';

import { useVolumeDiscountRatio } from '@/hooks/Pricing';
import { useShowStrikethroughPrice } from '@/hooks/useShowStrikethroughPrice';

type ProjectItemUnitPriceProps = {
  item: ProjectItem;
};

export const ProjectItemUnitPrice = ({ item }: ProjectItemUnitPriceProps) => {
  const { isFetching: isFetchingPricing, isLoading: isLoadingPricing } =
    usePricing();
  const itemizedPrice = useItemizedPriceData(item.id || '');
  const inverseVolumeDiscountRatio = useVolumeDiscountRatio(
    item.design?.cid || '',
    true,
  );
  const showStrikethroughPrice = useShowStrikethroughPrice();

  const className = isFetchingPricing ? 'pje-fetching-text' : '';

  if (!isFetchingPricing && isLoadingPricing) {
    return <Skeleton width={25} />;
  }

  if (!itemizedPrice?.unit_price) {
    return <Typography className={className}>--</Typography>;
  }

  const suffix = item.totalQuantity && item.totalQuantity > 1 ? ' each' : '';
  const unitPrice = Big(itemizedPrice.unit_price || 0);
  const strikethroughUnitPrice = unitPrice.times(inverseVolumeDiscountRatio);

  return (
    <>
      {showStrikethroughPrice && (
        <>
          <Typography
            className={className}
            sx={{ color: 'text.disabled', textDecoration: 'line-through' }}
            variant="uiTextSmall"
          >
            ${strikethroughUnitPrice.toFixed(2) + suffix}
          </Typography>{' '}
        </>
      )}
      <Typography className={className} variant="uiTextSmall">
        ${unitPrice.toFixed(2) + suffix}
      </Typography>
    </>
  );
};
